<div class="table-container">
  <div
    [@simpleFadeAnimation]="ready ? 'fadeIn': 'fadeOut'"
    *ngIf="details"
  >
    <div class="header">
      <h4>Filing Details</h4>
    </div>
    <table>
      <tbody>
        <tr>
          <td [innerHtml]="filingLink"></td>
          <td></td>
        </tr>
        <tr>
          <td>Total Value</td>
          <td>${{details.transactionValue | comma}}</td>
        </tr>
        <tr>
          <td>No. of shares</td>
          <td>{{details.transactionShares | comma }}</td>
        </tr>
        <tr>
          <td>Avg. Price</td>
          <td>${{details.transactionPricePerShare | comma}}</td>
        </tr>
        <tr>
          <td>Shares after</td>
          <td>{{details.sharesOwnedFollowingTransaction | comma }}</td>
        </tr>
        <tr>
          <td>Reported By</td>
          <td>{{details.reportingOwner}}</td>
        </tr>
        <tr>
          <td>Is 10% Owner</td>
          <td>{{details.isTenPercentOwner | roles:'role'}}</td>
        </tr>
        <tr>
          <td>Is Director</td>
          <td>{{details.isDirector | roles:'role'}}</td>
        </tr>
        <tr>
          <td>Is Officer</td>
          <td>{{details.isOfficer | roles:'role'}}</td>
        </tr>
        <tr>
          <td>Officer Title</td>
          <td>{{details.officerTitle | roles:'Officer title' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
